import styled from "styled-components";
import { animationDuration } from "../../theme";

export const StyledMenuButton = styled.button`
  color: var(--sinch-comp-color-menu-option-color-default-border-active);
  padding: 8px;
  opacity: 1;
  cursor: pointer;
  transition: opacity ${animationDuration}ms ease-in-out;

  &.enter-active {
    opacity: 0;
  }

  &.enter-done {
    opacity: 1;
  }

  &.exit-active {
    opacity: 0;
  }
`;
